import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import authService from '../../services/authService';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await authService.requestPasswordReset(email);
      setSuccess(res?.message || 'Si un compte existe, un email a été envoyé.');
    } catch (err) {
      setError(err.response?.data?.error || 'Impossible de traiter la demande. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">
        <h1 className="forgot-title">Mot de passe oublié</h1>
        <p className="forgot-subtitle">Saisis ton email, tu recevras un lien pour définir un nouveau mot de passe.</p>

        {error && <div className="forgot-alert forgot-alert--error">{error}</div>}
        {success && <div className="forgot-alert forgot-alert--success">{success}</div>}

        <form onSubmit={handleSubmit} className="forgot-form">
          <label className="forgot-label">Email</label>
          <div className="forgot-input">
            <Mail size={18} className="forgot-icon" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="nom@domaine.com"
              autoComplete="email"
            />
          </div>

          <button className="forgot-submit" type="submit" disabled={loading}>
            {loading ? 'Envoi...' : 'Envoyer le lien'}
          </button>
        </form>

        <div className="forgot-footer">
          <Link to="/login" className="forgot-link">Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
